module.exports = __webpack_public_path__ + "img/plus-one-logo.a8b127fa.svg";